<template>
  <div>
    <JadeBox hasPadding>
      <template>
        <div class="concluded__img--container">
          <img :src="require(`@/assets/kyc/step_3.svg`).default" />
        </div>
        <div class="concluded__text--container">
          <jade-text
            weight="bold"
            variant="heading-small"
          >
            {{ $t('title') }}
          </jade-text>
          <jade-text variant="text-medium">
            {{ $t('subtitle') }}
          </jade-text>
        </div>
        <jade-button
          icon="device-computer"
          variant="primary-solid"
          size="medium"
          class="concluded__button--container"
          @click="redirectToHome"
        >
          {{ $t('button') }}
        </jade-button>
      </template>
    </JadeBox>
  </div>
</template>

<script>
import JadeBox from '@jade/JadeBox/index.vue'
import JadeText from '@jade/JadeText/index.vue'
import JadeButton from '@jade/JadeButton/index.vue'

export default {
  name: 'Concluded',
  components: {
    JadeButton,
    JadeText,
    JadeBox
  },
  methods: {
    redirectToHome () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';

.concluded__img--container,
.concluded__text--container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.concluded__img--container {
  padding-bottom: var(--global-space-300, 24px);
}
.concluded__text--container {
  flex-direction: column;
  text-align: center;
  gap: var(--global-space-200, 16px);
  padding-bottom: var(--global-space-300, 24px);
}

.concluded__button--container {
  width: 100%;
}
</style>
<i18n>
  {
    "pt-BR": {
      "title": "Você concluiu todas as etapas!",
      "subtitle": "Aproveite as funcionalidades disponíveis e impulsione suas vendas com segurança.",
      "button": "Começar a usar"
    },
    "en-US": {
      "title": "You have completed all steps!",
      "subtitle": "Take advantage of the available features and boost your sales safely.",
      "button": "Get Started"
    }
  }
  </i18n>
